import pageLoading from './lib/pageLoading.js';
import modalImage from './lib/modalImage.js';
// import { isPage, isMobile } from "./lib/util";
// import scrollEffect from "./lib/scrollEffect.js";
// import observer from "./lib/observer.js";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import topValidation from 'top-validation';
import '@/scss/design.scss';

document.addEventListener('DOMContentLoaded', () => {
  pageLoading();
  modalImage();

  const navTrigger = document.querySelector('.btn-trigger');
  const globalNav = document.querySelector('.global_nav');

  if (navTrigger && globalNav) {
    const navLinks = globalNav.querySelectorAll('a');

    const setNavState = (open) => {
      navTrigger.classList.toggle('is-active', open);
      globalNav.classList.toggle('is-open', open);
      document.body.classList.toggle('is-nav-open', open);
      navTrigger.setAttribute('aria-expanded', String(open));
      globalNav.setAttribute('aria-hidden', String(!open));
    };

    setNavState(false);

    navTrigger.addEventListener('click', () => {
      const isOpen = navTrigger.getAttribute('aria-expanded') === 'true';
      setNavState(!isOpen);
    });

    navLinks.forEach((link) => {
      link.addEventListener('click', () => {
        setNavState(false);
      });
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 1024) {
        setNavState(false);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        setNavState(false);
      }
    });
  }

  const frontPageImageWrap = document.querySelector('.front_page_img_wrap');
  if (frontPageImageWrap) {
    const frontImageItems = Array.from(frontPageImageWrap.querySelectorAll('.img_list li'));

    const revealFrontImages = () => {
      frontImageItems.forEach((item, index) => {
        setTimeout(() => {
          item.classList.add('is_visible');
        }, index * 320);
      });
    };

    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        frontPageImageWrap.classList.add('is_inview');
        revealFrontImages();
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.35,
    });

    imageObserver.observe(frontPageImageWrap);
  }
});

if (document.body.classList.contains('contact')) {
  topValidation(); 
}


/* lenis
*************************************************** */
let lenis;

document.addEventListener('DOMContentLoaded', () => {
  // プラグイン登録は1回でOK
  gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

  // ページローディング
  pageLoading();

  // Lenis設定
  lenis = new Lenis();
  lenis.on('scroll', ScrollTrigger.update);
  function raf(time) {
    lenis.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  // パララックス: .index_price_unit
  const priceBg = document.querySelector('.index_price_bg');
  if (priceBg) {
    gsap.fromTo(
      priceBg,
      { y: '0%' },
      {
        y: '20%',
        ease: 'none',
        scrollTrigger: {
          trigger: priceBg.closest('.index_price_unit'),
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      }
    );
  }

  const contactBg = document.querySelector('.contact_tel_bg');
  if (contactBg) {
    gsap.fromTo(
      contactBg,
      { y: '0%' },
      {
        y: '20%',
        ease: 'none',
        scrollTrigger: {
          trigger: contactBg.closest('.contact_tel_contents'),
          start: 'top bottom',
          end: 'bottom top',
          scrub: true,
        },
      }
    );
  }
});


/* アコーディオンパネルが開閉する際のアニメーション
*************************************************** */
$(function(){
  $('.question_box').click(function(){
    let $question = $(this).find('.question').first();
    let $answer = $(this).find('.answer').first();

    if ($answer.is(':visible')) {
      $answer.slideUp(300, function() {
        $(this).css('display', 'none'); // 完全に閉じる
      });
      $question.removeClass("is_open"); // アイコン用のクラスを削除
    } else {
      $answer.css('display', 'flex').hide().slideDown(300); // flex を適用しつつスライド
      $question.addClass("is_open"); // アイコン用のクラスを追加
    }
  });
});


/* swiperの動き
*************************************************** */
$(function () {
  const mySwiper = new Swiper('.hd_swiper', {
    // Optional parameters
    effect: 'fade', // フェードのエフェクト
    autoplay: { // 自動再生
      delay: 3000, // 1.5秒後に次のスライド
      disableOnInteraction: false, // 矢印をクリックしても自動再生を止めない
    },
    loop: true,
    slidesPerView: 1,
    breakpoints: {
      768: {
        slidesPerView: 1,
        speed: 1200,
      },
    },

    // If we need paginationy
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
      type: "fraction", // ページネーションのtypeを指定
      formatFractionCurrent: function (number) {
        return '0' + number;
      },
      formatFractionTotal: function (number) {
        return ('0' + number).slice(-2); // 先頭に0をつける、二桁表示
      }
    },
    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    // And if we need scrollbar
    scrollbar: {
      el: '.swiper-scrollbar',
    },
  });

  if ($('.archive-slider').length) {
    const swiper2 = new Swiper(".archive-slider", {
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    $('.small_slide').click(function() {
      // サムネイル画像を1枚クリックしたら何枚目を取得しているのかを出力
      const index = $('.small_slide').index($(this));
      swiper2.slideTo(index);
    });
  }
});



/* ボヤけた画像をクリックして、はっきりと表示させる動き
*************************************************** */
$(function() {
  $('[href^="#"]').click(function(event){
      var id = $(this).attr('href');
      event.preventDefault();
      var top = $(id).offset().top;
      $('body, html').animate({
      scrollTop: top
    }, 500);
    });


  $(".pest_insects_img").click(function () {
    $(this).toggleClass('is_open');
  });
});

/*-------------------------------------------------------------------------------
  Contact Form 7 拡張プラグイン対応：遷移・スクロール制御
--------------------------------------------------------------------------------*/

// 1. スクロール実行関数（Lenis / GSAP 両対応）
const executeScroll = (selector) => {
  const target = document.querySelector(selector);
  const headerHeight = document.querySelector('.header')?.offsetHeight || 0;

  if (target) {
    // 確実に Lenis が初期化されているか確認
    if (typeof lenis !== 'undefined' && lenis !== null) {
      lenis.scrollTo(target, {
        offset: -headerHeight,
        duration: 1.2,
        immediate: false
      });
    } else {
      // LenisがなければGSAPで実行
      gsap.to(window, {
        duration: 1,
        scrollTo: { y: selector, offsetY: headerHeight },
        ease: "power2.inOut"
      });
    }
  }
};

// 2. 遷移後のハッシュ判定（thanksページ読み込み時）
window.addEventListener('load', () => {
  // プラグインが自動で slug:contact_thanks へ飛ばす際、
  // URLにハッシュがつかない場合があるため、URL自体に contact_thanks が含まれるかも判定
  if (window.location.hash === '#scroll' || window.location.pathname.includes('contact_thanks')) {
    // ページの描画とLenisの初期化を待つため、少し長めに待機
    setTimeout(() => {
      executeScroll('#thanks-anchor');
    }, 400);
  }
});

// 3. 確認画面ボタンやバリデーションエラー時のスクロール
// プラグイン独自のイベント 'wpcf7confirm' (もしあれば) や 標準イベントに反応
document.addEventListener('wpcf7invalid', () => {
  setTimeout(() => executeScroll('.contact_form_unit'), 100);
}, false);

// Contact Form 7の送信が「サーバー側で完了」した瞬間をブラウザでキャッチ
document.addEventListener('wpcf7mailsent', function(event) {
    // 確認画面プラグインが迷子になってループする前に、強制的にサンクスページへ切り替える
    window.location.href = '/contact_thanks/';
}, false);
